import React from 'react'
import { ForwardRefExoticComponent, SVGProps } from 'react'

import { Download } from '@factorialco/f0-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import TextElementQuestion from 'modules/forms/components/QuestionComponent/TextElementQuestion'
import { Element } from 'modules/forms/lib/Element'
import { Answer, Options } from 'modules/forms/lib/types'

export class FileElement extends Element {
  static create({ label, options = {} }: { label: string; options: Options }): FileElement {
    const el = new FileElement({
      label,
      description: options.description,
      mandatory: options.mandatory || options.locked,
    })
    if (options.locked) {
      el.lock()
    }

    return el
  }

  getName(): string {
    return i18n.t('forms.modals.elements.file')
  }

  getType(): FormsElementTypeEnum {
    return 'file'
  }

  getIcon(): ForwardRefExoticComponent<SVGProps<SVGSVGElement>> {
    return Download
  }

  getPreviewComponent(disabled?: boolean): React.ReactNode {
    return <TextElementQuestion element={this} disabled={disabled} />
  }

  getQuestionComponent(onChange: (answer: Answer) => void): React.ReactNode {
    return <TextElementQuestion element={this} onChange={onChange} />
  }
}
